import { render } from "./AddProductCategory.vue?vue&type=template&id=206fd7ec"
import script from "./AddProductCategory.vue?vue&type=script&lang=js"
export * from "./AddProductCategory.vue?vue&type=script&lang=js"

import "./AddProductCategory.vue?vue&type=style&index=0&id=206fd7ec&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__